import type { MenuRecipesState, RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'

export const getRecipeCoreIdByIdMap = (state: MenuRecipesState): Record<RecipeUUID, RecipeCoreId> =>
  Object.fromEntries(
    Object.entries(state.recipesV3.recipes).map(([recipeUuid, recipe]) => [
      recipeUuid,
      recipe.coreId,
    ]),
  ) as Record<RecipeUUID, RecipeCoreId>
